import React from "react";
import Skeleton from "react-loading-skeleton";

const LoadingMessages: React.FC = () => {
	return (
		<div className="space-y-2">
			<Skeleton
				count={2}
				height={40}
				className="w-1/2 rounded-xl bg-brand-primary/10"
				containerClassName="flex flex-col items-end justify-center gap-0.5"
			/>
			<Skeleton count={2} height={36} className="w-1/2 rounded-xl bg-brand-primary/10" />
			<Skeleton
				count={1}
				height={40}
				className="w-1/2 rounded-xl bg-brand-primary/10"
				containerClassName="flex items-center justify-end"
			/>
			<Skeleton count={1} height={36} className="w-1/2 rounded-xl bg-brand-primary/10" />
			<Skeleton
				count={3}
				height={36}
				className="w-1/2 rounded-xl bg-brand-primary/10"
				containerClassName="flex flex-col items-end justify-center gap-0.5"
			/>
			<Skeleton count={2} height={40} className="w-1/2 rounded-xl bg-brand-primary/10" />
		</div>
	);
};

export default LoadingMessages;
